
import { InternalAxiosRequestConfig } from "axios";
import { getServiceUrl, getAccessToken, getCacheTtl, getForceRefreshTimestamp } from "./StateManagement";
import { DRLog } from "./Logging";
import { axiosInstance } from "./AxiosInstance";

// Tracks the last force refresh timestamp that was handled in this runtime,
// so the cache is cleared only once per force refresh action. Seeded from the
// persisted value so a timestamp from a previous session isn't treated as new.
let lastForceRefreshTimestamp = getForceRefreshTimestamp();

function axiosMiddleware(config: InternalAxiosRequestConfig) {
    config.baseURL = "https://" + getServiceUrl();

    // Apply dynamic cache configuration per request
    const cacheTtl = getCacheTtl();
    const forceRefreshTimestamp = getForceRefreshTimestamp();

    if (cacheTtl === 0) {
        // TTL 0 means cache is disabled
        (config as any).cache = { ...(config as any).cache, enabled: false };
    } else {
        // Set TTL in milliseconds (stored in minutes)
        (config as any).cache = { ...(config as any).cache, ttl: cacheTtl * 60 * 1000 };
    }

    // On a new force refresh, clear the cache once at the beginning. Afterwards the
    // request continues like a normal refresh so identical requests reuse the cache.
    if (forceRefreshTimestamp && forceRefreshTimestamp !== lastForceRefreshTimestamp) {
        lastForceRefreshTimestamp = forceRefreshTimestamp;
        axiosInstance.storage.clear?.();
    }

    // Log every outgoing request
    const logDetails = {
        method: config.method,
        url: config.baseURL + config.url,
        params: config.params || null,
        data: config.data || null,
        isCached: (config as any).cached || false,
        cacheTtl: cacheTtl,
        forceRefreshTimestamp: forceRefreshTimestamp
    };
    DRLog("DEBUG", `HTTP REQUEST: ${JSON.stringify(logDetails)}`);

    return (async (config) => {
        config.headers.Authorization = `Bearer ${getAccessToken()}`;
        return config;
    })(config);
}

export default axiosMiddleware;